import { positions } from "../constants/positions";
import { AO_HOST } from "../../client/aoHost";
import { client } from "../../client";
import transparentPng from "../../constants/transparentPng";
import fileExists from "../../utils/fileExists";

export async function setBackgroundImage(elementid: string, bgname: string, bgpart: string) {

  let url;
  let success = false;
  for (const extension of client.background_extensions) {
    url = `${AO_HOST}background/${encodeURI(bgname.toLowerCase())}/${bgpart}${extension}`;
    const exists = await fileExists(url);

    if (exists) {
      success = true;
      break;
    }
  }
  if (success)
    (<HTMLImageElement>document.getElementById(elementid)).src = url;
  else
    (<HTMLImageElement>document.getElementById(elementid)).src = transparentPng;
  return success;
}


/**
 * Changes the viewport background based on a given position.
 *
 * Valid positions: `def, pro, hld, hlp, wit, jud, jur, sea`
 * @param {string} position the position to change into
 */
export const set_side = async ({
  position,
  showSpeedLines,
  showDesk,
}: {
  position: string;
  showSpeedLines: boolean;
  showDesk: boolean;
}) => {
  const view = document.getElementById("client_fullview")!;
  let bench: HTMLImageElement;
  if (["def", "pro", "wit"].includes(position)) {
    bench = <HTMLImageElement>(
      document.getElementById(`client_${position}_bench`)
    );
  } else {
    bench = <HTMLImageElement>document.getElementById("client_bench_classic");
  }

  let court: HTMLImageElement;
  if ("def,pro,wit".includes(position)) {
    court = <HTMLImageElement>(
      document.getElementById(`client_court_${position}`)
    );
  } else {
    court = <HTMLImageElement>document.getElementById("client_court_classic");
  }

  let bg;
  let desk;
  let speedLines;

  if ("def,pro,hld,hlp,wit,jud,jur,sea".includes(position)) {
    bg = positions[position].bg;
    desk = positions[position].desk;
    speedLines = positions[position].speedLines;
  } else {
    bg = `${position}`;
    desk = { ao2: `${position}_overlay`, ao1: "_overlay" };
    speedLines = "defense_speedlines.gif";
  }

  if (showSpeedLines === true) {
    // Speed lines (zoom) resolve from the character's chat-category misc
    // folder first (e.g. misc/dd/defense_speedlines.webp), then the theme.
    // Upstream hardcoded themes/default/<name>.gif, which 404'd for chat
    // categories whose speedlines live in misc/<chat> as .webp etc.
    const speedBase = (speedLines || "defense_speedlines.gif").replace(
      /\.[^.]+$/,
      "",
    );
    const miscFolder = client.viewport.getChatmsg().miscFolder || "default";
    const speedExts = [".webp", ".apng", ".gif", ".png"];
    const speedCandidates = [
      ...speedExts.map(
        (e) => `${AO_HOST}misc/${encodeURI(miscFolder)}/${speedBase}${e}`,
      ),
      ...speedExts.map((e) => `${AO_HOST}themes/default/${speedBase}${e}`),
    ];
    let resolvedSpeed = `${AO_HOST}themes/default/${encodeURI(speedLines)}`;
    for (const c of speedCandidates) {
      if (await fileExists(c)) {
        resolvedSpeed = c;
        break;
      }
    }
    court.src = resolvedSpeed;
  } else {
    setBackgroundImage(court.id, client.viewport.getBackgroundName(), bg);
  }

  let benchFound = false;
  if (showDesk === true && desk) {
    const bg_folder = client.viewport.getBackgroundFolder();
    const stems = [desk.ao2, desk.ao1].filter((s): s is string => typeof s === "string");
    outer:
    for (const stem of stems) {
      for (const ext of client.background_extensions) {
        const url = `${bg_folder}${stem}${ext}`;
        if (await fileExists(url)) {
          bench.src = url;
          bench.style.opacity = "1";
          benchFound = true;
          break outer;
        }
      }
    }
    if (!benchFound) {
      bench.src = transparentPng;
    }
  } else {
    bench.style.opacity = "0";
  }

  // Panorama desk overlay (court_overlay.png): only used as a FALLBACK when
  // this position has no per-position desk, since per-position desks are
  // more accurately placed. Also hidden whenever the desk is hidden (e.g.
  // during a zoom), so it never re-introduces the desk.
  const courtOverlay = document.getElementById("client_court_overlay");
  if (courtOverlay) {
    courtOverlay.style.opacity = showDesk === true && !benchFound ? "1" : "0";
  }

  if ("def,pro,wit".includes(position)) {
    view.style.display = "";
    document.getElementById("client_classicview")!.style.display = "none";
    // #client_fullview is a five-screen-wide stitched strip that pans by
    // shifting its left edge. Every per-position element (court, bench,
    // character) carries a matching left offset: def 0, wit 200%, pro 400%.
    // The behind-effects layer is one screen wide, so it needs the same offset
    // or it stays parked over the def screen and behind-layer effects
    // (dramathink, whitethink, mobmafia) vanish at wit and pro.
    const behind = document.getElementById("client_fg_behind_full");
    switch (position) {
      case "def":
        view.style.left = "0";
        if (behind) behind.style.left = "0";
        break;
      case "wit":
        view.style.left = "-200%";
        if (behind) behind.style.left = "200%";
        break;
      case "pro":
        view.style.left = "-400%";
        if (behind) behind.style.left = "400%";
        break;
    }
  } else {
    view.style.display = "none";
    document.getElementById("client_classicview").style.display = "";
  }
};
